import { CartLinesUpdateEvent } from '@shopify/events';

/**
 * Me & My — product-card quick add by size.
 * Moves each card's size overlay into its gallery, and on click adds the
 * chosen variant to the cart using the theme's own cart event so the cart
 * drawer refreshes and opens automatically.
 */

function cartSectionIds() {
  const ids = [];
  document.querySelectorAll('cart-items-component[data-section-id]').forEach((el) => {
    if (el.dataset.sectionId) ids.push(el.dataset.sectionId);
  });
  return ids;
}

async function addVariant(variantId, btn) {
  const deferred = CartLinesUpdateEvent.createPromise();

  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(variantId), quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: cartSectionIds().join(','),
      }),
    });
    const data = await res.json();

    if (data.status) {
      deferred.reject(new Error(data.message || 'Add to cart failed'));
      return;
    }

    const cart = await fetch('/cart.js').then((r) => r.json());
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'mm-quick-add',
        itemCount: 1,
        sections: data.sections,
        didError: false,
      },
    });
  } catch (err) {
    deferred.reject(err);
  }
}

// Click a size → add to cart (don't follow the card link).
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.mm-qa__btn');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  if (btn.disabled || btn.getAttribute('aria-disabled') === 'true' || btn.classList.contains('is-loading')) return;
  const id = btn.getAttribute('data-variant-id');
  if (!id) return;
  btn.classList.add('is-loading');
  addVariant(id, btn).finally(() => btn.classList.remove('is-loading'));
});

// Move each quick-add overlay into its card gallery so it overlays the image.
function place(root) {
  (root || document).querySelectorAll('[data-mm-qa]').forEach((qa) => {
    const card = qa.closest('.product-card');
    if (!card) return;
    const gallery = card.querySelector('.card-gallery');
    if (gallery && qa.parentElement !== gallery) {
      const oldParent = qa.parentElement;
      gallery.appendChild(qa);
      // The custom-liquid block leaves an empty wrapper behind — collapse it.
      if (oldParent && oldParent !== gallery && oldParent.children.length === 0) {
        oldParent.style.display = 'none';
      }
    }
  });
}

place();
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => place());
}
// Re-place after filtering / pagination / infinite scroll re-renders the grid.
const mo = new MutationObserver(() => place());
mo.observe(document.documentElement, { childList: true, subtree: true });
